import React, { useEffect, useState } from "react";
import { addOrUpdateOfficeAddressApi, countryListApi, getAllOfficeAddressesApi } from "../../../utils/ApiEndpointFunctions";

export default function OfficeAddress() {
  const [showModal, setShowModal] = useState(false);
  const [address, setAddress] = useState("");
  const [editId, setEditId] = useState(null); // current edit row id
  const [country, setCountry] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);       // Table loader
const [adding, setAdding] = useState(false);         // Modal Add button loader/disable

  const filterCountry = async (inputValue) => {
      try {
        const res = await countryListApi(inputValue)
        if (res.status === 200) {
          let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
          setCountryOptions(cityOption);
        }
      } catch (error) {
        console.log(error)
      }
    };

  // Fetch all office addresses on mount
  useEffect(() => {
    filterCountry();
    fetchAllAddresses();
  }, []);

  const fetchAllAddresses = async () => {
    try {
          setLoading(true);  // loader start
      const res = await getAllOfficeAddressesApi();
      if (res.status === 200) {
        // Assuming res.data.data is an array of office addresses
        setData(
  res.data?.data?.map((item) => ({
    id: item.id,
    address: item.address,
    country: item.countryName || "",
    countryId: item.countryId,   // 👈 add this
  })) || []
);

      }
    } catch (error) {
      console.error("Error fetching office addresses:", error);
    }
    finally {
    setLoading(false);  // loader end
  }
  };

  const handleAdd = async () => {
  if (!address || !country) {
    alert("Please enter address and select country");
    return;
  }

  try {
    setAdding(true);

    const payload = {
      id: editId || undefined, // agar edit hai to id bhejna, warna undefined
      address,
      countryId: country,
    };

    const res = await addOrUpdateOfficeAddressApi(payload);
    if (res.status === 200) {
      await fetchAllAddresses();
      setAddress("");
      setCountry("");
      setEditId(null);  // reset editId
      setShowModal(false);
    }
  } catch (error) {
    console.error("Error in add/update office address:", error);
  } finally {
    setAdding(false);
  }
};

  return (
   <>
      <div className="card">
        <div className="card-header">
          <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
            <h1>Office Address</h1>
            <div style={{ display: "-webkit-inline-box" }}>
              <div className="position-relative my-3">
                <div className="d-flex gap-2 justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowModal(true)}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
  {loading ? (
    <p>Loading office addresses...</p>
  ) : data.length === 0 ? (
    <p>No office addresses added yet.</p>
  ) : (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Address</th>
          <th>Country</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
  {data.map((item, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{item.address}</td>
      <td>{item.country}</td>
      <td style={{ position: "relative" }}>
        <div className="dropdown">
          <button
            className="btn  p-0 border-0"
            type="button"
            id={`dropdownMenuButton${item.id}`}
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ fontSize: "1.5rem", lineHeight: 1 }}
          >
            <span style={{ cursor: "pointer" }}>⋮</span>
          </button>
          <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${item.id}`}>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  setEditId(item.id);
                  setAddress(item.address);
                  setCountry(item.countryId);
                  setShowModal(true);
                }}
              >
                Update
              </button>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  ))}
</tbody>

    </table>
  )}
</div>

      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal show fade"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
  {editId ? "Update Office Address" : "Add Office Address"}
</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Office Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="mb-3">
  <label className="form-label">Country</label>
  <select
  className="form-select"
  value={country}
  onChange={(e) => setCountry(e.target.value)}
  disabled={!!editId} // Update me disable
>
  <option value="">Select Country</option>
  {countryOptions.map((c) => (
    <option key={c.value} value={c.value}>
      {c.label}
    </option>
  ))}
</select>

</div>

              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleAdd} disabled={adding}>
  {adding ? (editId ? "Updating..." : "Adding...") : (editId ? "Update" : "Add")}
</button>

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
